<div class="app-shell">
  <!-- Para quien navega con teclado: salta la barra superior y la secundaria y cae en el contenido. -->
  <a class="saltar-contenido" href="#contenido-principal" (click)="saltarAlContenido($event)" data-saltar-contenido>Saltar al contenido</a>
  <app-navbar />
  <app-subbar />
  <main class="app-content" id="contenido-principal" tabindex="-1">
    <!-- Al cambiar de obra con el selector la pantalla se vuelve a armar (llave nueva): carga todo con la obra nueva, sin recargar el navegador. -->
    @for (llave of [obraGlobal.llave()]; track llave) {
      <router-outlet />
    }
  </main>
  <app-footer />
  <app-notificacion-toast />

  <!-- Aviso corto de lo que el portal hizo por la persona (cambio de obra) -->
  @if (avisoSvc.actual(); as aviso) {
    <div class="aviso-global aviso-global--{{ aviso.tipo }}" role="status" aria-live="polite" data-aviso-global>
      <span class="pi aviso-global__icono" [class.pi-info-circle]="aviso.tipo !== 'alerta'" [class.pi-exclamation-triangle]="aviso.tipo === 'alerta'" aria-hidden="true"></span>
      <span class="aviso-global__texto">{{ aviso.texto }}</span>
      <button class="aviso-global__cerrar" type="button" aria-label="Cerrar el aviso" (click)="avisoSvc.cerrar()"><span class="pi pi-times" aria-hidden="true"></span></button>
    </div>
  }

  <!-- Toast de acceso denegado -->
  @if (permisosSvc.mensajeDenegado()) {
    <div class="acceso-denegado-toast" role="alert">
      <span class="pi pi-lock acceso-denegado-toast__icon"></span>
      <span class="acceso-denegado-toast__msg">{{ permisosSvc.mensajeDenegado() }}</span>
    </div>
  }
</div>

<!-- Confirmación única de acciones destructivas (ConfirmationService, ver PageHeader) -->
<p-confirmdialog [style]="{ width: '440px', maxWidth: '92vw' }" />

<!-- Modal de inactividad -->
<p-dialog
  header="¿Sigues ahí?"
  [visible]="inactivitySvc.modalVisible()"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
  [style]="{width: '400px'}"
  styleClass="siscon-dialog"
>
  <div class="dialog-body">
    <div class="inactivity-body">
      <i class="pi pi-clock inactivity-body__icon"></i>
      <p class="inactivity-body__msg">Tu sesión cerrará por inactividad.</p>
      <div class="inactivity-body__countdown">
        <span class="inactivity-body__secs">{{ inactivitySvc.countdown() }}</span>
        <span class="inactivity-body__unit">segundos</span>
      </div>
    </div>
  </div>
  <ng-template #footer>
    <div class="dialog-footer">
      <button class="dialog-btn dialog-btn--cancel" type="button" (click)="inactivitySvc.cerrarSesion()">
        <span class="pi pi-sign-out"></span> Cerrar sesión
      </button>
      <button class="dialog-btn dialog-btn--confirm" type="button" (click)="inactivitySvc.continuarSesion()">
        <span class="pi pi-check"></span> Continuar sesión
      </button>
    </div>
  </ng-template>
</p-dialog>
